module.exports = "/_next/static/images/PersonalizeOnEveryChannel@2x-66f134509c0ee84f75e1eafbbe323c06.png";